export default {
    Metadata: {
        Name: "Max",
        Description: "Returns the max between the values specified.",
        Syntax: "Max(value, value)",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(Value1, Value2) {
        if (Value1 >= Value2) {
            return Value1;
        }
        else {
            return Value2;
        }
    },
};

